import { fetchCustomAppearance } from '~/data/appearance';
import { fetchApplicationConfig } from '~/data/applicationConfig';
import { getAttributes } from '~/data/attributes';
import { fetchCompanyData } from '~/data/company';
import { fetchCostCenters } from '~/data/costCenters';
import { fetchCustomTranslations } from '~/data/customTranslations';
import { fetchEmployees } from '~/data/employees';
import { fetchEnums } from '~/data/enums';
import { fetchLanguages } from '~/data/languages';
import { fetchOrganizationUnits } from '~/data/orgunits';
import { fetchUnitPositions } from '~/data/unitPositions';
import { DispatchReduxFetch } from '~/hooks/initializeData';
import { store } from '~/store';

export const updateUI2ReduxStores = (
  updateStores: (string | DispatchReduxFetch)[],
) => {
  // Validate requested strings
  const updateValidStores = Object.values(DispatchReduxFetch).filter((s) =>
    updateStores.includes(s),
  );

  if (updateValidStores.length === 0) {
    return;
  }

  // Get data from other stores required for some dispatch calls
  const storeState = store.getState();
  const { userDetails } = storeState.auth;

  // Do Redux Store Dispatches
  const doDispatchFetch = (dispatchFetch: DispatchReduxFetch) => {
    switch (dispatchFetch) {
      case DispatchReduxFetch.AllEmployees:
        if (!!userDetails) {
          const { roles } = userDetails;
          store.dispatch(fetchEmployees({ myRoles: roles }));
        }
        return;
      case DispatchReduxFetch.AllEnums:
        store.dispatch(fetchEnums());
        return;
      case DispatchReduxFetch.ApplicationConfig:
        store.dispatch(fetchApplicationConfig());
        return;
      case DispatchReduxFetch.CompanyData:
        store.dispatch(fetchCompanyData());
        return;
      case DispatchReduxFetch.AllOrgUnits:
        if (!!userDetails) {
          const { roles, employeeId } = userDetails;
          store.dispatch(
            fetchOrganizationUnits({ myRoles: roles, myId: employeeId }),
          );
        }
        return;
      case DispatchReduxFetch.AllCostCenters:
        store.dispatch(fetchCostCenters());
        return;
      case DispatchReduxFetch.AllUnitPositions:
        store.dispatch(fetchUnitPositions());
        return;
      case DispatchReduxFetch.AllLegalEntities:
        store.dispatch(fetchCompanyData());
        return;
      case DispatchReduxFetch.EmploymentDetailsAttributes:
        store.dispatch(getAttributes('EMPLOYMENT_DETAILS'));
        return;
      case DispatchReduxFetch.CustomAppearance:
        store.dispatch(fetchCustomAppearance());
        return;
      case DispatchReduxFetch.Languages:
        store.dispatch(fetchLanguages());
        return;
      case DispatchReduxFetch.CustomTranslations:
        store.dispatch(fetchCustomTranslations());
        return;
      default:
        return;
    }
  };

  updateValidStores.map((store) => doDispatchFetch(store));
};
